(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    function initEmailSignupBlocks() {
    const emailSignupBlocks = document.querySelectorAll('.email-signup-block');

    emailSignupBlocks.forEach((block) => {
      const form = block.querySelector('.email-signup__form');
      const message = block.querySelector('.email-signup__message--success');
      const input = block.querySelector('.email-signup__input');

      if (!form || !message || !input) return;

      form.insertAdjacentElement('afterend', message);

      const storageKey = `moeve:email-signup:subscribed:${input.id}`;
      const rememberSuccess = () => {
        try {
          sessionStorage.setItem(storageKey, 'true');
        } catch (error) {
        }
      };
      const showSuccessMessage = () => {
        form.hidden = true;
        message.classList.remove('hidden');
        input.setAttribute('aria-describedby', message.id);
      };
      const handleSubmit = () => {
        if (!form.checkValidity()) return;

        rememberSuccess();
      };

      form.addEventListener('submit', handleSubmit);

      try {
        if (!message.classList.contains('hidden')) {
          rememberSuccess();
        }

        if (sessionStorage.getItem(storageKey) === 'true') {
          showSuccessMessage();
        }
      } catch (error) {
        if (!message.classList.contains('hidden')) {
          showSuccessMessage();
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEmailSignupBlocks);
  } else {
    initEmailSignupBlocks();
  }
  } catch(e) { console.error(e); }
})();

})();
